import axios from 'axios';
import config from '../config';
import applyTokenRefreshInterceptor from '../utils/tokenRefreshInterceptor';
import applyAuthRetryInterceptor from '../utils/applyAuthRetryInterceptor';

// Configure axios instance for CC (Covered Calls) service
const ccServiceClient = axios.create({
  baseURL: config.api.ccServiceUrl,
  timeout: 60000,
  headers: {}
});

// Add request interceptor to include auth token
ccServiceClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// On 401, attempt a token refresh and retry once before logging out
applyAuthRetryInterceptor(ccServiceClient);

// Proactively refresh token before any request if within 30-minute expiry window
applyTokenRefreshInterceptor(ccServiceClient);

export const ccService = {
  // Accounts
  getAccounts: async () => {
    const response = await ccServiceClient.get('/covered-calls/accounts');
    return response.data;
  },
  getStatistics: async () => {
    const response = await ccServiceClient.get('/covered-calls/statistics');
    return response.data;
  },
  createAccount: async (data) => {
    const response = await ccServiceClient.post('/covered-calls/accounts', data);
    return response.data;
  },
  updateAccount: async (accountNumber, data) => {
    const response = await ccServiceClient.put(`/covered-calls/accounts/${accountNumber}`, data);
    return response.data;
  },
  deleteAccount: async (accountNumber) => {
    const response = await ccServiceClient.delete(`/covered-calls/accounts/${accountNumber}`);
    return response.data;
  },

  // Config
  getOptionsConfig: async () => {
    const response = await ccServiceClient.get('/covered-calls/config');
    return response.data;
  },
  saveOptionsConfig: async (data) => {
    const response = await ccServiceClient.post('/covered-calls/config', data);
    return response.data;
  },

  // File processing
  processFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await ccServiceClient.post('/covered-calls/process-file', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },
  cleanupVariance: async () => {
    const response = await ccServiceClient.delete('/covered-calls/cleanup-variance');
    return response.data;
  },
  // Generation
  generateCoveredCalls: async (optionsData) => {
    const response = await ccServiceClient.post('/covered-calls/generate', optionsData);
    return response.data;
  },
  // Historical files
  getHistoricalFiles: async () => {
    const response = await ccServiceClient.get('/covered-calls/historical-files');
    return response.data;
  },
  rerunVariance: async (historicalFile) => {
    const response = await ccServiceClient.post('/covered-calls/rerun-variance', { historical_file: historicalFile });
    return response.data;
  }
};

export default ccService;
